import { render } from "./SelectSlide.vue?vue&type=template&id=135df832&scoped=true"
import script from "./SelectSlide.vue?vue&type=script&lang=js"
export * from "./SelectSlide.vue?vue&type=script&lang=js"

import "./SelectSlide.vue?vue&type=style&index=0&id=135df832&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-135df832"]])

export default __exports__